import React from "react";
import { Modal, Table } from "react-bootstrap";

interface StatusFaqModalProps {
  show: boolean;
  handleClose: () => void;
}

export const statusData = [
  { status: "Accepted", desc: "Request has been approved." },
  { status: "Rejected", desc: "Request has been turned down." },
  { status: "Cancelled", desc: "Request is called off." },
  { status: "Completed", desc: "Request is finished." },
  { status: "Deleted", desc: "Request is removed from the system." },
  { status: "Pending Review", desc: "Request is created and waiting for further action." },
  { status: "In Progress", desc: "Request is actively being worked on." },
  { status: "Under Review", desc: "Request has been submitted and it is under review by WDTP team." },
  { status: "Send to Owner", desc: "Request is sent to the container owner for their approval." },
  { status: "Admin Accepted", desc: "An admin has approved the request." },
  { status: "Admin Accepted for Warehouse", desc: "Admin has approved it for warehouse handling on behalf of warehouse." },
  { status: "Warehouse Completed", desc: "Warehouse has finished its part and ready." },
  { status: "In Transit", desc: "Containers are on the move." },
  { status: "Delivered", desc: "Shipment has arrived." },
  { status: "Admin Rejected", desc: "An admin has rejected the request." },
  { status: "In Process", desc: "Request is being actively processed." },
  { status: "Re Processing", desc: "Request is being run through the process again, usually after a failure." },
  { status: "Reassign to Admin", desc: "Request is sent back to an admin for further action." },
  { status: "Send to Warehouse", desc: "Request is routed to the warehouse team." },
  { status: "Confirmed for Warehouse", desc: "Warehouse has confirmed it received the request." },
  { status: "In Stage for Warehouse", desc: "Containers are staged at the warehouse, waiting on next steps." },
  { status: "Source Accepted", desc: "The sending account owner has approved the transfer." },
  { status: "Source Rejected", desc: "The sending account owner has declined." },
  { status: "Destination Accepted", desc: "The receiving account owner has approved the transfer." },
  { status: "Destination Rejected", desc: "The receiving account owner has declined." },
  { status: "Ownership Transferred", desc: "Ownership of the container officially changes." },
  { status: "Sold", desc: "Used for Private Sale completion." },
  { status: "Published", desc: "Listing goes live and becomes visible in marketplace search." },
  { status: "Unpublished", desc: "Listing is taken down from search, but can be restored later." },
  { status: "Republished", desc: "A previously unpublished listing is put back into search." },
  { status: "Finalized", desc: "Sell Request has reached its final agreed outcome." },
  { status: "Assigned", desc: "Owner is changed within a Account owner." },
  { status: "Uploaded", desc: "The file has been attached to the request." },
  { status: "Uploading", desc: "File is actively being processed in the background." },
  { status: "Upload Failed", desc: "File processing did not succeed." },
  { status: "Closed", desc: "Request has been closed out." },
  { status: "Processing", desc: "Request is currently being worked on." },
  { status: "Success", desc: "A sub-step or operation completed successfully." },
  { status: "Failed", desc: "A sub-step or operation did not succeed." },
  { status: "Approved", desc: "A separate approval step has been granted." },
  { status: "Invoice Sent", desc: "An invoice has been issued for the request." },
  { status: "Payment Received", desc: "Payment for the request has come in." },
  { status: "Confirmed", desc: "A simple confirmation step has been completed." },
  { status: "In Stage", desc: "Warehouse side status to know where exactly a request containers are currently lying." },
  { status: "Scheduled", desc: "Request or action has been scheduled for later." }
];

const StatusFaqModal: React.FC<StatusFaqModalProps> = ({ show, handleClose }) => {
  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="lg"
      scrollable
      className="modal__wd modal__wd--submitSellReq"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          Status Reference & Descriptions
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="table-responsive service-detail-table-wrapper" style={{ maxHeight: "60vh" }}>
          <Table className="service-detail-table mb-0">
            <thead>
              <tr>
                <th style={{ width: "30%" }}>Status</th>
                <th>Description</th>
              </tr>
            </thead>
            <tbody>
              {statusData.map((row, idx) => (
                <tr key={idx}>
                  <td style={{ fontWeight: 600 }}>{row.status}</td>
                  <td>{row.desc}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default StatusFaqModal;
